/** Filled, illustrated tab icons (match refs/mockup-*.png tab bars). Two tones: currentColor body + knocked-out detail via the parchment stroke. */
import type { SVGAttributes } from 'preact/compat';

type P = SVGAttributes<SVGSVGElement>;
const svg = (p: P) => ({ viewBox: '0 0 32 32', fill: 'currentColor', stroke: 'none', ...p });
const cut = { stroke: 'var(--ui-parchment-soft, #F2ECE1)', strokeWidth: 1.4, strokeLinecap: 'round' as const, fill: 'none' };

export const TabReserve = (p: P) => ( // acacia
  <svg {...svg(p)}>
    <path d="M3 13.2C5 8.4 9.6 5.6 16 5.6s11 2.8 13 7.6c-3.3 1.6-8 2.5-13 2.5s-9.7-.9-13-2.5Z" />
    <path d="M14.6 14.5h2.8l.6 12.5h-4Z" />
    <path d="M16 18.5c-2.4-.8-4.2-2.4-5.2-4.6M16 17c2-.8 3.6-2.2 4.6-4.2" {...cut} />
    <path d="M9 27.2h14" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
  </svg>
);
export const TabMap = (p: P) => ( // folded map with pin
  <svg {...svg(p)}>
    <path d="M3 8.5 11 6l10 2.5L29 6v17.5L21 26l-10-2.5L3 26Z" />
    <path d="M11 6v17.5M21 8.5V26" {...cut} />
    <path d="M16 3.5a4.2 4.2 0 0 0-4.2 4.2c0 3 4.2 7.3 4.2 7.3s4.2-4.300 4.200-7.300A4.200 4.200 0 0 0 16 3.500Z" stroke="var(--ui-parchment-soft, #F2ECE1)" stroke-width="1.2" />
    <circle cx="16" cy="7.7" r="1.5" fill="var(--ui-parchment-soft, #F2ECE1)" />
  </svg>
);
export const TabHerd = (p: P) => ( // antelope head
  <svg {...svg(p)}>
    <path d="M10.5 12C9 9.800 7.800 6.800 7.400 3.200l1.600.6c.300 2.400 1.200 4.600 2.600 6.400ZM21.500 12c1.500-2.200 2.700-5.200 3.100-8.800l-1.600.6c-.3 2.400-1.200 4.600-2.600 6.400Z" />
    <path d="M9.800 11.600 4.600 9.200l.3 1.800 4.200 2.900ZM22.200 11.600l5.200-2.400-.3 1.800-4.200 2.900Z" />
    <path d="M16 28.500c-3.600 0-5.800-2.800-5.800-6.700 0-3.100 1.200-5.500 2.600-7 .7-.8 1.900-1.300 3.200-1.300s2.500.5 3.200 1.300c1.400 1.500 2.600 3.900 2.600 7 0 3.900-2.200 6.700-5.800 6.700Z" />
    <circle cx="13" cy="19" r="1" fill="var(--ui-parchment-soft, #F2ECE1)" />
    <circle cx="19" cy="19" r="1" fill="var(--ui-parchment-soft, #F2ECE1)" />
    <ellipse cx="16" cy="25" rx="2" ry="1.300" fill="var(--ui-parchment-soft, #F2ECE1)" />
  </svg>
);
export const TabPark = (p: P) => ( // tree over a rail fence
  <svg {...svg(p)}>
    <path d="M16 3.500c-3.300 0-5.800 2.500-5.800 5.500 0 .6.100 1.200.300 1.700-1.700.7-2.800 2.300-2.800 4.100 0 2.500 2.200 4.400 4.600 4.400h7.400c2.400 0 4.600-1.900 4.600-4.400 0-1.800-1.100-3.400-2.800-4.100.2-.5.300-1.100.3-1.700 0-3-2.500-5.500-5.800-5.500Z" />
    <path d="M15 19h2v3h-2Z" />
    <path d="M3 22.500h26v2H3ZM3 26.500h26v2H3Z" />
    <path d="M6 20.500h2.200v10H6ZM14.900 22h2.200v8.500h-2.200ZM23.800 20.500H26v10h-2.200Z" />
  </svg>
);
export const TabOffice = (p: P) => ( // reserve office building
  <svg {...svg(p)}>
    <path d="M16 3 4 9.500V12h24V9.500Z" />
    <path d="M6 13.500h4v11H6ZM14 13.500h4v11h-4ZM22 13.500h4v11h-4Z" />
    <path d="M3 26h26v2.500H3Z" />
    <path d="M15 24.500h2V26h-2Z" fill="var(--ui-parchment-soft, #F2ECE1)" />
  </svg>
);
